import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19b6166c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "pointer r-text" }
const _hoisted_3 = { class: "p-mt-3" }
const _hoisted_4 = {
  key: 0,
  class: "c-text"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "ไม่มีข้อมูลที่อยู่", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "p-d-flex d-jc-between" }
const _hoisted_9 = { class: "w-100" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-pencil" }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "p-d-flex d-jc-between" }
const _hoisted_14 = { class: "w-100" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-trash" }, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "p-grid p-mt-2" }
const _hoisted_20 = { class: "p-col-12 p-md-12 p-lg-12" }
const _hoisted_21 = { class: "p-col-12 p-md-6 p-lg-6" }
const _hoisted_22 = { class: "p-col-12 p-md-6 p-lg-6" }
const _hoisted_23 = { class: "p-col-12 p-md-6 p-lg-6" }
const _hoisted_24 = { class: "p-col-12 p-md-6 p-lg-6" }
const _hoisted_25 = { class: "p-col-12 p-md-6 p-lg-6" }
const _hoisted_26 = { class: "p-col-12 p-md-6 p-lg-6" }
const _hoisted_27 = { class: "p-mt-3" }
const _hoisted_28 = { class: "p-mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputTextCustom = _resolveComponent("InputTextCustom")!
  const _component_InputAutoComplete = _resolveComponent("InputAutoComplete")!
  const _component_InputTextArea = _resolveComponent("InputTextArea")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_ModalAlertError = _resolveComponent("ModalAlertError")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Dialog, {
      header: "ที่อยู่ของฉัน",
      visible: _ctx.displayModal,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.displayModal) = $event)),
      style: { width: '700px' },
      modal: true,
      position: "top"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          (!_ctx.displayAddAdress)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("u", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openCreateAddress()))
                  }, " เพิ่มที่อยู่ ")
                ]),
                _createElementVNode("div", _hoisted_3, [
                  (_ctx.addressList.length == 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addressList, (address, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: 'shipping' + index
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["bg-color-secondary p-p-3 p-my-2 rounded pointer f-size-14", {
                  active: address.id == _ctx.transaction.buyerInfo.shippingAddressId,
                }]),
                        onClick: ($event: any) => (_ctx.handleSelectAddress(address))
                      }, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, _toDisplayString(address.address) + " " + _toDisplayString(address.road), 1),
                          _createElementVNode("div", {
                            onClick: _withModifiers(($event: any) => (_ctx.editAddress(address)), ["stop"]),
                            class: "p-ml-2"
                          }, _hoisted_12, 8, _hoisted_10)
                        ]),
                        _createElementVNode("div", null, _toDisplayString(address.subdistrict) + " " + _toDisplayString(address.district), 1),
                        _createElementVNode("div", null, _toDisplayString(address.province) + " " + _toDisplayString(address.zipcode), 1),
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, _toDisplayString(address.shippingNote ? address.shippingNote : "-"), 1),
                          _createElementVNode("div", {
                            class: "pointer",
                            onClick: _withModifiers(($event: any) => (_ctx.onDeleteAddress(address)), ["stop"])
                          }, _hoisted_17, 8, _hoisted_15)
                        ])
                      ], 10, _hoisted_7)
                    ]))
                  }), 128))
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_InputTextCustom, {
                      "model-value": _ctx.form.address,
                      textFloat: "ที่อยู่",
                      placeholder: "ที่อยู่",
                      type: "text",
                      name: "address",
                      isRequired: "",
                      isValidate: _ctx.v$.form.address.$error,
                      v: _ctx.v$.form.address,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.address = $event)),
                      class: "f-regular"
                    }, null, 8, ["model-value", "isValidate", "v"])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_InputTextCustom, {
                      "model-value": _ctx.form.road,
                      textFloat: "ถนน",
                      placeholder: "ถนน",
                      type: "text",
                      name: "road",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.road = $event)),
                      class: "f-regular"
                    }, null, 8, ["model-value"])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_InputAutoComplete, {
                      "model-value": _ctx.form.zipcode,
                      placeholder: "รหัสไปรษณีย์",
                      title: "รหัสไปรษณีย์",
                      text: "รหัสไปรษณีย์",
                      name: "zipcode",
                      oninput: "if( this.value.length > 5 )  this.value = this.value.slice(0,5)",
                      type: "number",
                      isRequired: "",
                      isValidate: _ctx.v$.form.zipcode.$error,
                      v: _ctx.v$.form.zipcode,
                      field: 'zipcode',
                      options: _ctx.filteredProvince,
                      isAddress: true,
                      "onUpdate:modelValue": _ctx.handlerZipcode,
                      onOnSearchList: _ctx.searchProvince,
                      onOnSelectItem: _ctx.onSelectItem,
                      onOnClearItem: _ctx.onClearItem
                    }, null, 8, ["model-value", "isValidate", "v", "options", "onUpdate:modelValue", "onOnSearchList", "onOnSelectItem", "onOnClearItem"])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_InputTextCustom, {
                      "model-value": _ctx.form.province,
                      textFloat: "จังหวัด",
                      placeholder: "จังหวัด",
                      type: "text",
                      name: "province",
                      isRequired: "",
                      isValidate: _ctx.v$.form.province.$error,
                      isDisplay: true,
                      v: _ctx.v$.form.province,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.province = $event)),
                      class: "f-regular"
                    }, null, 8, ["model-value", "isValidate", "v"])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_InputTextCustom, {
                      "model-value": _ctx.form.district,
                      textFloat: "อำเภอ",
                      placeholder: "อำเภอ",
                      type: "text",
                      name: "district",
                      isRequired: "",
                      isValidate: _ctx.v$.form.district.$error,
                      isDisplay: true,
                      v: _ctx.v$.form.district,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.district = $event)),
                      class: "f-regular"
                    }, null, 8, ["model-value", "isValidate", "v"])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_InputTextCustom, {
                      "model-value": _ctx.form.subdistrict,
                      textFloat: "ตำบล/แขวง",
                      placeholder: "ตำบล/แขวง",
                      type: "text",
                      name: "subdistrict",
                      isRequired: "",
                      isValidate: _ctx.v$.form.subdistrict.$error,
                      v: _ctx.v$.form.subdistrict,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.subdistrict = $event)),
                      class: "f-regular"
                    }, null, 8, ["model-value", "isValidate", "v"])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(_component_InputTextArea, {
                      "model-value": _ctx.form.shippingNote,
                      textFloat: "บันทึก",
                      placeholder: "บันทึก",
                      type: "text",
                      name: "note",
                      rows: "4",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.shippingNote = $event)),
                      class: "f-regular"
                    }, null, 8, ["model-value"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(_component_Button, {
                    label: "ตกลง",
                    class: "p-button-outlined w-100 text-white",
                    style: _normalizeStyle({
                'background-color': _ctx.brand.colorThemeMain,
                'border-color': _ctx.brand.colorThemeMain,
              }),
                    autofocus: "",
                    onClick: _ctx.beforeSaveAddress
                  }, null, 8, ["style", "onClick"])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(_component_Button, {
                    label: "ยกเลิก",
                    onClick: _ctx.closeModalAddAddress,
                    class: "w-100 p-button-outlined p-button-secondary"
                  }, null, 8, ["onClick"])
                ])
              ]))
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_ModalAlertError, {
      modalMessage: _ctx.modalMessage,
      onOnHideModalError: _ctx.onHideModalError,
      ref: "modalAlertError"
    }, null, 8, ["modalMessage", "onOnHideModalError"])
  ]))
}